<template>
  <section
    ref="$block"
    class="osk-home-blocks-social"
  >
    <div class="osk-wrapper">
      <h2
        v-if="data.title"
        class="osk-home-blocks-social__title"
      >
        {{ data.title }}
      </h2>

      <div class="osk-home-blocks-social__links">
        <a
          v-for="(item, index) in items"
          :key="index"
          class="osk-home-blocks-social__link"
          :href="item.link"
          target="_blank"
        >
          <img
            :src="item.image"
            :alt="item.title"
            class="osk-home-blocks-social__img"
          >

          <span class="osk-home-blocks-social__text">
            {{ item.title }}
          </span>
        </a>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { PrimaryContentDTO } from '~/restAPI/data-contracts';
import { AnalyticsEvents } from '~/types/analytics';

type TSocialDTO = {
  id: string
  image: string
  link: string
  title: string
}

const props = defineProps<{
  data: PrimaryContentDTO
}>();

const $block = ref<ComponentPublicInstance>();

const { $addEvent } = useNuxtApp();

useScrollEvent($block, event);

const analytics = computed(() => ({
  chapter: props.data.contentType,
  chapter_index: props.data.chapterIndex,
  segment_id: props.data.segmentId,
  id_chapter: props.data.id,
}));

const items = computed(() => (props.data.contentList ?? []) as TSocialDTO[]);

function event() {
  $addEvent(AnalyticsEvents.BlockView, analytics.value);
}
</script>

<style scoped lang="scss">
@import "~/assets/scss/settings/index";

.osk-home-blocks-social {
  padding-bottom: 42px;

  @include media-query(lg-and-up) {
    display: none;
  }

  &__title {
    @include font-heading;
    padding-bottom: 22px;
  }

  &__links {
    margin-bottom: -8px;
  }

  &__link {
    background: #F4F4F4;
    border-radius: 30px;
    display: inline-flex;
    align-items: center;
    padding: 8px 12px;
    margin-right: 8px;
    height: 36px;
    margin-bottom: 8px;
    flex-shrink: 0;
  }

  &__img {
    margin-right: 4px;
    height: 20px;
    flex-shrink: 0;
  }

  &__text {
    flex-shrink: 0;
  }
}
</style>
